import React from 'react';
import { TabInterface } from '../../../interfaces/tabs/TabInterface';

const Tab = ({ children }: TabInterface) => {
  return <>{children}</>;
};

export default Tab;
